// extracted by mini-css-extract-plugin
module.exports = {"saveObjectPanelHeader":"SaveObjectPanelHeader_saveObjectPanelHeader__2YaF_","header":"SaveObjectPanelHeader_header__2YerF"};